export default __webpack_public_path__ + "static/media/new-profile-icon.ec2b5f22.svg";